import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider,
} from 'react-router-dom'

import Root from './Root'
import { Form } from './pages/form'
import {
	FormAdminConnection,
	FormAdminPasswordReset,
	FormAdmin,
	FormCreation,
} from './pages/form-admin'
import { ValidatorProvider } from '@/utils/validatorProvider'
import { pdfjs } from 'react-pdf'
import { CookiesProvider } from 'react-cookie'

import './App.css'

// Served verbatim from public/ (copied there by scripts/copy-pdf-worker.js).
// Avoids webpack rewriting the worker into a module with unresolved imports.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`

const router = createBrowserRouter(
	createRoutesFromElements([
		<Route path='/' element={<Root />} />,
		<Route path='/form' element={<Form />} />,
		<Route path='/form-admin-connection' element={<FormAdminConnection />} />,
		<Route
			path='/form-admin-password-reset'
			element={<FormAdminConnection mode='password-reset' />}
		/>,
		// Where the emailed link lands: the token is the last path segment, which
		// is how the back-end builds it in passwordResetURL.
		<Route path='/form-admin-password-reset/:token' element={<FormAdminPasswordReset />} />,
		<Route path='/form-admin' element={<FormAdmin />} />,
		<Route path='/form-creation' element={<FormCreation />} />,
	]),
)

function App() {
	return (
		<CookiesProvider>
			<ValidatorProvider>
				<RouterProvider router={router} />
			</ValidatorProvider>
		</CookiesProvider>
	)
}

export default App
